/**
 * DrawerChannelRules - Channel Rules & Status im ProductActionDrawer
 * Plan 012: Merge Products + Channel Readiness
 *
 * Zeigt pro Channel: Score-Bar + Fehleranzahl + Top-Issues.
 */

import { CheckCircle2, XCircle } from 'lucide-react'
import { Badge } from '@/components/v2/ui'
import { ReadinessScoreBar } from '@/components/v2/channel-readiness/ReadinessScoreBar'
import type { ReadinessScore } from '@/lib/api/channel-readiness'

interface DrawerChannelRulesProps {
  scores: ReadinessScore[]
  channelNames: Record<string, string>
}

export function DrawerChannelRules({ scores, channelNames }: DrawerChannelRulesProps) {
  if (scores.length === 0) {
    return (
      <p className="drawer-channel-rules text-sm text-neutral-500 px-4 py-3">
        Keine Channel-Regeln konfiguriert.
      </p>
    )
  }

  return (
    <div className="drawer-channel-rules px-4 py-3 space-y-4">
      <h3 className="text-xs font-semibold text-neutral-500 uppercase tracking-wide">
        Channel Rules & Status
      </h3>
      {scores.map(score => {
        const name = channelNames[score.channel_id] ?? score.channel_id
        const isReady = score.issue_count === 0

        return (
          <div key={score.channel_id} className="space-y-1.5">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-neutral-700 dark:text-neutral-300">
                {name}
              </span>
              <Badge variant={isReady ? 'success' : 'error'} className="text-xs flex items-center">
                {isReady
                  ? <><CheckCircle2 className="w-3 h-3 mr-1" />Bereit</>
                  : <><XCircle className="w-3 h-3 mr-1" />{score.issue_count} Fehler</>
                }
              </Badge>
            </div>
            <ReadinessScoreBar score={score.readiness_score} size="sm" showLabel={false} />
            {score.issues.slice(0, 2).map((issue, i) => (
              <p key={i} className="text-xs text-red-500 dark:text-red-400 truncate">
                {issue.message}
              </p>
            ))}
          </div>
        )
      })}
    </div>
  )
}
